import { render, staticRenderFns } from "./CrearCalendarioModal.vue?vue&type=template&id=05d7c033&"
import script from "./CrearCalendarioModal.vue?vue&type=script&lang=ts&"
export * from "./CrearCalendarioModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports